import { render, staticRenderFns } from "./WebChatMenu.vue?vue&type=template&id=7610653e"
import script from "./WebChatMenu.vue?vue&type=script&lang=js"
export * from "./WebChatMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports